(function () {
  'use strict';
  if (window.MezcaleroStockNotify) {
    window.MezcaleroStockNotify.mount(document);
    return;
  }

  const STOCK_URL = 'https://mensaje-stock.dev-707.workers.dev';
  const KLAVIYO_URL = 'https://a.klaviyo.com/client/';
  const COMPANY_ID = 'XPPJzu'; // Public onsite identifier, never an Admin API key.
  const NOTIFY_ME_URL = '/apps/notify-me';
  // June 2026 pre-sale allocation supplied by the merchant. Badge eligibility
  // survives sales; these limits are NOT inventory quantities or purchase rules.
  const PRESALE_MIN_SIZE = {
    '7531575574782': 6,   // Hannah Black
    '5975439245498': 6,   // Mezcal Stone Moka
    '5975438557370': 6,   // Chiara Black
    '8937608675582': 7,   // Selena Black
    '5975439212730': 6,   // Jude Black
    '8939942904062': 6,   // Hannah Brunette
    '8940146819326': 6.5, // Mezcal Galactic
    '8023425876222': 6.5, // Maye Stone Moka (Maye Black in the original table)
    '8937986719998': 7,   // Selena Red
    '8938060579070': 6.5  // Hannah Aqua
  };
  const PRESALE_SIZES = ['6', '6.5', '7', '7.5', '8', '8.5', '9', '9.5', '10'];
  const controllers = new Map();

  async function request(url, options, timeout) {
    const abort = new AbortController();
    const timer = setTimeout(() => abort.abort(), timeout);
    try {
      const response = await fetch(url, Object.assign({}, options, { signal: abort.signal }));
      if (!response.ok) throw new Error('Request failed');
      return options.method === 'POST' ? response : await response.json();
    } finally {
      clearTimeout(timer);
    }
  }

  function stockMode(variant, stock) {
    if (!variant) return null;
    // Only trust the worker's complete boolean contract. Unknown is not zero.
    if (stock && typeof stock.has_bodega_stock === 'boolean' && typeof stock.show_message === 'boolean') {
      if (stock.has_bodega_stock) return null;
      if (stock.show_message) return 'us'; // Existing worker: US empty, Alianza has stock.
      if (variant.available === false) return 'sold_out';
      // Could be an untracked/pre-order item. Do not invent physical availability.
      return null;
    }
    // Shopify availability is a safe generic sold-out fallback during outages.
    // Metafields alone can be stale and cannot prove stock in Mexico.
    return variant.available === false ? 'sold_out' : null;
  }

  function createController(block) {
    const root = block.closest('[data-section-type="product"]');
    if (!root) return null;
    let variants;
    try {
      variants = JSON.parse(block.querySelector('[data-notify-us-variants]').dataset.variants);
      if (!Array.isArray(variants) || !variants.length || variants.some(variant =>
        !variant || !/^\d+$/.test(variant.id) || !Array.isArray(variant.options) || typeof variant.available !== 'boolean'
      )) return null;
    } catch (_) { return null; }
    const byId = new Map(variants.map(variant => [String(variant.id), variant]));
    const form = block.querySelector('[data-notify-us-form]');
    const email = form.querySelector('[name="email"]');
    const button = form.querySelector('[type="submit"]');
    const error = block.querySelector('[data-notify-us-error]');
    const confirmation = block.querySelector('[data-notify-us-confirmation]');
    const message = block.querySelector('[data-notify-us-message]');
    const label = block.querySelector('[data-notify-us-variant]');
    const master = root.querySelector('[name="id"]');
    const options = Array.from(root.querySelectorAll('.single-option-selector'));
    const accepted = new Set();
    let current = null;
    let mode = null;
    let generation = 0;
    let pending = false;
    let disposed = false;
    let optionTimer;

    function key(variant, target, address) {
      return [variant.id, target, address.trim().toLowerCase()].join('|');
    }

    function selectedVariant() {
      // Resolve options, not the master select: legacy theme leaves its old ID
      // selected when a size/color combination does not exist.
      if (options.length) {
        return variants.find(variant => options.every((option, index) => {
          const optionIndex = /^option([1-3])$/.exec(option.dataset.index || '');
          return variant.options[optionIndex ? Number(optionIndex[1]) - 1 : index] === option.value;
        })) || null;
      }
      return byId.get(String(master ? master.value : block.dataset.initialVariantId)) || null;
    }

    function render() {
      block.hidden = !mode;
      if (!mode || !current) return;
      const local = mode === 'us';
      message.textContent = local ? block.dataset.usMessage : block.dataset.soldOutMessage;
      label.textContent = current.title === 'Default Title' ? '' : 'Selected size / style: ' + current.title;
      label.hidden = !label.textContent;
      button.textContent = pending ? 'Submitting…' : local ? 'Notify me when available in the US' : 'Notify me when available';
      button.disabled = pending;
      email.disabled = pending;
      form.setAttribute('aria-busy', String(pending));
      const done = accepted.has(key(current, mode, email.value));
      form.hidden = done;
      confirmation.hidden = !done;
      confirmation.textContent = local
        ? 'Done! We will let you know as soon as it is available locally in the US.'
        : "You're in! We'll let you know when this size is back in stock.";
    }

    function applyStock(variant, stock) {
      mode = stockMode(variant, stock);
      // Made-to-order products do not collect restock requests. Keep stock notices active.
      if (block.dataset.notifyExcluded === 'true') mode = null;
      if (mode === 'us' && (block.dataset.usEnabled !== 'true' || !block.dataset.usMessage.trim())) mode = null;
      const badge = root.querySelector('#bodega-stock-badge');
      const presale = root.querySelector('#presale-badge');
      const minimumSize = PRESALE_MIN_SIZE[block.dataset.productId];
      const hasPresaleRule = typeof minimumSize === 'number';
      if (hasPresaleRule) {
        // These ten products use US size as option1. Never let the US-stock
        // badge label an unlisted size (e.g. Chiara 5/5.5) as pre-sale.
        const size = variant && variant.options[0];
        const eligible = PRESALE_SIZES.includes(size) && Number(size) >= minimumSize;
        if (badge) badge.style.display = 'none';
        if (presale) presale.style.display = eligible ? 'block' : 'none';
      }
      if (stock) {
        const alert = root.querySelector('#alianza-stock-alert');
        if (alert) alert.style.display = stock.show_message === true ? 'block' : 'none';
        if (!hasPresaleRule) {
          if (badge) badge.style.display = stock.has_bodega_stock === true ? 'block' : 'none';
          if (presale && typeof stock.is_presale === 'boolean') presale.style.display = stock.is_presale ? 'block' : 'none';
        }
      }
      render();
    }

    function hideStockNotices() {
      root.querySelectorAll('#alianza-stock-alert, #bodega-stock-badge, #presale-badge').forEach(node => {
        node.style.display = 'none';
      });
    }

    async function loadStock(variant) {
      const stock = await request(STOCK_URL + '?variant_id=' + encodeURIComponent(variant.id), { cache: 'no-store' }, 6000);
      if (!stock || typeof stock.has_bodega_stock !== 'boolean' || typeof stock.show_message !== 'boolean' ||
        (stock.has_bodega_stock && stock.show_message)) throw new Error('Invalid inventory response');
      return stock;
    }

    async function select(variant, force) {
      if (!force && current === variant) return;
      const version = ++generation;
      current = variant;
      error.hidden = true;
      hideStockNotices();
      applyStock(variant, null);
      if (!variant) return;
      try {
        const stock = await loadStock(variant);
        if (!disposed && generation === version) applyStock(variant, stock);
      } catch (_) {
        // Keep only the generic Shopify fallback; a failed request is not stock=0.
      }
    }

    function sync() { select(selectedVariant(), true); }
    function onHistory() {
      const id = new URLSearchParams(window.location.search).get('variant') || block.dataset.initialVariantId;
      const variant = byId.get(String(id));
      if (!variant) return select(null, true);
      options.forEach((option, index) => { option.value = variant.options[index]; });
      if (master) master.value = variant.id;
      // Let the base theme update prices, images and purchase controls as well.
      if (options.length) options[0].dispatchEvent(new Event('change', { bubbles: true }));
      select(variant, true);
    }
    function onVariant(event) {
      select(byId.get(String(event.detail?.variant?.id)) || null);
    }
    function onChange(event) {
      if (!event.target.matches('.single-option-selector, [name="id"]')) return;
      clearTimeout(optionTimer);
      optionTimer = setTimeout(() => select(selectedVariant()), 0);
    }

    async function submit(event) {
      event.preventDefault();
      if (pending || disposed) return;
      email.value = email.value.trim();
      if (!form.reportValidity() || !current || !mode) return;
      const variant = current;
      const target = mode;
      const address = email.value;
      const subscriptionKey = key(variant, target, address);
      if (accepted.has(subscriptionKey)) return render();
      pending = true;
      error.hidden = true;
      render();
      try {
        // Recheck at submission; do not subscribe using a stale inventory result.
        let stock = null;
        try { stock = await loadStock(variant); } catch (_) { /* generic fallback only */ }
        if (disposed) return;
        const freshMode = stockMode(variant, stock);
        if (freshMode !== target) {
          if (!stock && target === 'us') throw new Error('Inventory unavailable');
          if (current === variant) applyStock(variant, stock);
          return;
        }
        // US-local interest goes to our app, which owns the real subscriber
        // list and calls Klaviyo itself once Bodega US restocks (see the
        // "Re-Stock: Bodega US recibe stock" Flow). Native Shopify BIS
        // subscriptions use aggregate catalog inventory, so Klaviyo is
        // called directly from here only for the generic sold-out case.
        if (target === 'us') {
          await request(NOTIFY_ME_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              email: address,
              variantId: 'gid://shopify/ProductVariant/' + variant.id,
              productId: 'gid://shopify/Product/' + block.dataset.productId
            })
          }, 12000);
        } else {
          const payload = {
            data: {
              type: 'back-in-stock-subscription',
              attributes: {
                profile: { data: { type: 'profile', attributes: { email: address } } },
                channels: ['EMAIL']
              },
              relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variant.id } } }
            }
          };
          await request(KLAVIYO_URL + 'back-in-stock-subscriptions/?company_id=' + COMPANY_ID, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', revision: '2026-07-15' },
            body: JSON.stringify(payload)
          }, 12000);
        }
        accepted.add(subscriptionKey);
        if (!disposed && current === variant && mode === target) {
          render();
          confirmation.focus();
        }
      } catch (_) {
        if (!disposed && current === variant && mode === target) {
          // Retain the form and email for a deliberate retry; never fake success.
          error.hidden = false;
        }
      } finally {
        pending = false;
        if (!disposed) render();
      }
    }

    root.setAttribute('data-stock-notify-ready', '');
    root.addEventListener('variantChange', onVariant);
    // Custom size/color buttons emit non-bubbling change events on the selects.
    root.addEventListener('change', onChange, true);
    form.addEventListener('submit', submit);
    email.addEventListener('input', render);
    window.addEventListener('pageshow', sync);
    window.addEventListener('popstate', onHistory);
    sync();
    return {
      dispose() {
        disposed = true;
        generation++;
        clearTimeout(optionTimer);
        root.removeAttribute('data-stock-notify-ready');
        root.removeEventListener('variantChange', onVariant);
        root.removeEventListener('change', onChange, true);
        form.removeEventListener('submit', submit);
        email.removeEventListener('input', render);
        window.removeEventListener('pageshow', sync);
        window.removeEventListener('popstate', onHistory);
      }
    };
  }

  function mount(scope) {
    // Related colors replace the PDP DOM without a Shopify section-unload event.
    // Retire old listeners/requests before binding to the newly inserted form.
    controllers.forEach((controller, block) => {
      if (!block.isConnected) {
        controller.dispose();
        controllers.delete(block);
      }
    });
    scope.querySelectorAll('[data-notify-us-stock]').forEach(block => {
      if (controllers.has(block)) return;
      const controller = createController(block);
      if (controller) controllers.set(block, controller);
    });
  }
  window.MezcaleroStockNotify = { mount };
  mount(document);
  // AJAX-inserted script tags do not execute; initialize on the theme's own event.
  document.addEventListener('productLayoutLoad', () => mount(document));
  document.addEventListener('shopify:section:load', event => mount(event.target));
  document.addEventListener('shopify:section:unload', event => {
    controllers.forEach((controller, block) => {
      if (event.target.contains(block)) {
        controller.dispose();
        controllers.delete(block);
      }
    });
  });
})();
